import { GetAllShifts } from "hooks/apollo/shift/shift.gql";
import filter from "lodash/filter";

export function insertShift(newShift, proxy) {
  const shifts = read(proxy);

  const updatedShifts = [newShift].concat(filter(shifts, (existingShift) => existingShift.id !== newShift.id));

  write(updatedShifts, proxy);
}

export function removeShift(shiftId, proxy) {
  const internalShift = proxy.identify({ __typename: "Shift", id: shiftId });
  proxy.evict({ id: internalShift });
  proxy.gc();
}

function read(proxy) {
  const { shifts } = proxy.readQuery({ query: GetAllShifts });

  return shifts;
}

function write(shifts, proxy) {
  proxy.writeQuery({
    data: { shifts },
    query: GetAllShifts,
  });
}
